import { all, takeLatest } from "redux-saga/effects";

import {
  ADD_EMAIL,
  ADD_MEDIA,
  ADD_PROMO_CODE,
  CHANGE_ARTIST_STATUS,
  CHANGE_PASSWORD,
  CHANGE_PROMO_CODE_STATUS,
  CHANGE_USER_STATUS,
  SEND_USER_EMAIL,
  SEND_BULK_EMAIL,
  DELETE_USER,
  CREATE_USER,
  DELETE_ARTIST,
  DELETE_FEEDBACK,
  DELETE_MEDIA,
  DELETE_MEDIA_LYRICS,
  DELETE_PROMO_CODE,
  EDIT_MEDIA,
  FORGOT_PASSWORD,
  GET_ARTIST_LISTING,
  GET_AUDIO_PURCHASES,
  GET_FEEDBACKS,
  GET_MEDIA_COUNT,
  GET_MEDIA_LISTING,
  GET_MEDIA_PLAY_COUNT_STATS,
  GET_MEDIA_TYPE_STATS,
  GET_PROMO_CODES,
  GET_STREAMS_COUNT,
  GET_SUBSCRIPTIONS_COUNT,
  GET_USERS_COUNT,
  GET_USER_LISTING,
  GET_USER_LOCATIONS,
  GET_USER_LOCATION_STATS,
  GET_USER_SIGNUP_STATS,
  GET_VIDEO_PURCHASES,
  LOGOUT,
  REPLY_FEEDBACK,
  RESET_PASSWORD,
  SIGN_IN,
  VERIFY_OTP,
  GET_ADS_LISTING,
  DELETE_ADS,
  EDIT_ADS,
  CREATE_ADS,
  APPROVE_ARTIST,
  GET_REPORTS,
  GET_INTERVIEWS_LISTING,
  DELETE_INTERVIEWS,
  LIVE_STREAMING,
  DELETE_EVENT,
  END_EVENT,
  SEND_EVENT_NOTIFICATION,
  SEND_EVENT_EMAIL,
  GET_BACKGROUND_LISTING,
  ADD_BACKGROUND,
  DELETE_BACKGROUND,
} from "../constants";
import {
  AdsMiddleware,
  AuthMiddleware,
  DashboardMiddleware,
  FeedbackMiddleware,
  MediaMiddleware,
  PromoCodeMiddleware,
  UserMiddleware,
  ArtistMiddleware,
  InterviewsMiddleware,
  LiveMiddleware,
} from "../middlewares";
import ReportMiddleware from "../middlewares/reportsMiddleware";

export function* Sagas() {
  yield all([
    //auth
    yield takeLatest(SIGN_IN, AuthMiddleware.SignIn),
    yield takeLatest(LOGOUT, AuthMiddleware.Logout),
    yield takeLatest(FORGOT_PASSWORD, AuthMiddleware.ForgotPassword),
    yield takeLatest(VERIFY_OTP, AuthMiddleware.VerifyOTP),
    yield takeLatest(RESET_PASSWORD, AuthMiddleware.ResetPassword),
    yield takeLatest(CHANGE_PASSWORD, AuthMiddleware.ChangePassword),

    //media
    yield takeLatest(GET_MEDIA_LISTING, MediaMiddleware.GetMediaListing),
    yield takeLatest(DELETE_MEDIA, MediaMiddleware.DeleteMedia),
    yield takeLatest(ADD_MEDIA, MediaMiddleware.AddMedia),
    yield takeLatest(EDIT_MEDIA, MediaMiddleware.EditMedia),
    yield takeLatest(DELETE_MEDIA_LYRICS, MediaMiddleware.DeleteMediaLyrics),

    //user management
    yield takeLatest(GET_USER_LISTING, UserMiddleware.GetUserListing),
    yield takeLatest(GET_USER_LOCATIONS, UserMiddleware.GetUserLocations),
    yield takeLatest(CHANGE_USER_STATUS, UserMiddleware.ChangeUserStatus),
    yield takeLatest(SEND_USER_EMAIL, UserMiddleware.SendUserEmail),
    yield takeLatest(SEND_BULK_EMAIL, UserMiddleware.SendBulkEmail),
    yield takeLatest(DELETE_USER, UserMiddleware.DeleteUser),
    yield takeLatest(CREATE_USER, UserMiddleware.CreateUser),

    //ads management
    yield takeLatest(GET_ADS_LISTING, AdsMiddleware.GetAdsListing),
    yield takeLatest(DELETE_ADS, AdsMiddleware.DeleteAds),
    yield takeLatest(EDIT_ADS, AdsMiddleware.EditAds),
    yield takeLatest(CREATE_ADS, AdsMiddleware.CreateAds),

    //artist management
    yield takeLatest(GET_ARTIST_LISTING, ArtistMiddleware.GetArtistListing),
    yield takeLatest(CHANGE_ARTIST_STATUS, ArtistMiddleware.ChangeArtistStatus),
    yield takeLatest(DELETE_ARTIST, ArtistMiddleware.DeleteArtist),
    yield takeLatest(ADD_EMAIL, ArtistMiddleware.AddEmail),
    yield takeLatest(APPROVE_ARTIST, ArtistMiddleware.ApproveArtist),

    //dashboard
    yield takeLatest(GET_USERS_COUNT, DashboardMiddleware.GetUsersCount),
    yield takeLatest(
      GET_SUBSCRIPTIONS_COUNT,
      DashboardMiddleware.GetSubscriptionsCount
    ),
    yield takeLatest(GET_MEDIA_COUNT, DashboardMiddleware.GetMediaCount),
    yield takeLatest(GET_STREAMS_COUNT, DashboardMiddleware.GetStreamsCount),
    yield takeLatest(
      GET_AUDIO_PURCHASES,
      DashboardMiddleware.GetAudioPurchases
    ),
    yield takeLatest(
      GET_VIDEO_PURCHASES,
      DashboardMiddleware.GetVideoPurchases
    ),
    yield takeLatest(
      GET_USER_SIGNUP_STATS,
      DashboardMiddleware.GetUserSignupStats
    ),
    yield takeLatest(
      GET_MEDIA_PLAY_COUNT_STATS,
      DashboardMiddleware.GetMediaPlayCountStats
    ),
    yield takeLatest(
      GET_MEDIA_TYPE_STATS,
      DashboardMiddleware.GetMediaTypeStats
    ),
    yield takeLatest(
      GET_USER_LOCATION_STATS,
      DashboardMiddleware.GetUserLocationStats
    ),

    //media feedback
    yield takeLatest(GET_FEEDBACKS, FeedbackMiddleware.GetFeedbacks),
    yield takeLatest(DELETE_FEEDBACK, FeedbackMiddleware.DeleteFeedback),
    yield takeLatest(REPLY_FEEDBACK, FeedbackMiddleware.ReplyFeedback),

    //promo code
    yield takeLatest(GET_PROMO_CODES, PromoCodeMiddleware.GetPromoCodes),
    yield takeLatest(DELETE_PROMO_CODE, PromoCodeMiddleware.DeletePromoCode),
    yield takeLatest(ADD_PROMO_CODE, PromoCodeMiddleware.AddPromoCode),
    yield takeLatest(
      CHANGE_PROMO_CODE_STATUS,
      PromoCodeMiddleware.ChangePromoCodeStatus
    ),

    //reports
    yield takeLatest(GET_REPORTS, ReportMiddleware.GetReports),

    //live streaming
    yield takeLatest(LIVE_STREAMING, LiveMiddleware.getLiveStreaming),

    //Interviews
    yield takeLatest(
      GET_INTERVIEWS_LISTING,
      InterviewsMiddleware.GetInterviewsListing
    ),
    yield takeLatest(DELETE_INTERVIEWS, InterviewsMiddleware.DeleteInterviews),
    yield takeLatest(DELETE_EVENT, LiveMiddleware.deleteEvent),
    yield takeLatest(END_EVENT, LiveMiddleware.endEvent),
    yield takeLatest(
      SEND_EVENT_NOTIFICATION,
      LiveMiddleware.sendEventNotification
    ),
    yield takeLatest(SEND_EVENT_EMAIL, LiveMiddleware.sendEventEmail),
    yield takeLatest(
      GET_BACKGROUND_LISTING,
      InterviewsMiddleware.GetBackgroundListing
    ),
    yield takeLatest(ADD_BACKGROUND, InterviewsMiddleware.AddBackground),
    yield takeLatest(DELETE_BACKGROUND, InterviewsMiddleware.DeleteBackground),
  ]);
}
